import { addListenerToSelector } from "@rootreeweb/js-lib";
import { hide, show } from "./rtBasePolyfills";
import RTPop from "./RTPop";
export class Popup {
    /** @param data */
    constructor(data) {
        this.id = data.id;
        this.timeout = data.timeout;
        this.trigger = data.trigger;
        this.preventDefault = data.preventDefault;
        this.fullWidth = data.fullWidth;
        this.containerSelector = `.rt-pop-announcement[data-popup_id="${this.id}"]`;
        this.container = document.querySelector(this.containerSelector);
        this.setupPopupOnPage();
    }
    conditionsMet() {
        const path = window.location.pathname;
        const cookieNotSet = RTPop.getCookie(`rt_pop_${this.id}`) === "";
        const notInBuilder = !path.includes("?et_fb=1");
        const isAutoDisplaying = !this.isNonAutoDisplaying();
        return cookieNotSet && notInBuilder && isAutoDisplaying;
    }
    display() {
        show(this.containerSelector);
        this.addListeners();
        this.setPopupCookie();
    }
    hide() {
        hide(this.containerSelector);
    }
    isNonAutoDisplaying() {
        const { timeout } = this;
        return timeout < 0;
    }
    setupPopupOnPage() {
        if (this.conditionsMet()) {
            this.display();
        }
        if (this.trigger !== "") {
            this.setupTrigger();
        }
    }
    setupTrigger() {
        addListenerToSelector(this.trigger, "click", (e) => {
            if (this.preventDefault) {
                //&& window.innerWidth > 1000
                e.preventDefault();
                e.stopPropagation();
            }
            this.display();
        });
    }
    addListeners() {
        const addStopListeners = () => {
            addListenerToSelector(".rt-pop-announcement-content-full-width", "click", (e) => {
                e.stopPropagation();
            });
            addListenerToSelector(".rt-pop-announcement-content", "click", (e) => {
                e.stopPropagation();
            });
        };
        const addCloseListeners = () => {
            // When the user clicks anywhere outside the modal, close it
            window.addEventListener("click", () => {
                this.hide();
            });
            addListenerToSelector(`.rt-pop-announcement-close[data-popup_id="${this.id}"]`, "click", () => {
                this.hide();
            });
        };
        addStopListeners();
        addCloseListeners();
    }
    setPopupCookie() {
        if (this.timeout > 0) {
            RTPop.setCookie(`rt_pop_${this.id}`, `1`, this.timeout);
        }
    }
}
